"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var glUtils = require("./utils");
var IndexBuffer = /** @class */ (function () {
    function IndexBuffer(gl, dataOption) {
        this.gl = gl;
        this.name = glUtils.nonNull(this.gl.createBuffer());
        if (dataOption)
            this.setData(dataOption);
    }
    IndexBuffer.prototype.release = function () {
        this.gl.deleteBuffer(this.name);
    };
    IndexBuffer.prototype.bind = function (cb) {
        this.gl.bindBuffer(this.gl.ELEMENT_ARRAY_BUFFER, this.name);
        cb();
        this.gl.bindBuffer(this.gl.ELEMENT_ARRAY_BUFFER, null);
    };
    IndexBuffer.prototype.setData = function (_a) {
        var usage = _a.usage, array = _a.array;
        this.usage = usage || this.gl.STATIC_DRAW;
        this._length = array.length;
        this.gl.bindBuffer(this.gl.ELEMENT_ARRAY_BUFFER, this.name);
        this.gl.bufferData(this.gl.ELEMENT_ARRAY_BUFFER, array, this.usage);
        this.gl.bindBuffer(this.gl.ELEMENT_ARRAY_BUFFER, null);
    };
    Object.defineProperty(IndexBuffer.prototype, "length", {
        get: function () {
            return this._length;
        },
        enumerable: true,
        configurable: true
    });
    return IndexBuffer;
}());
exports.IndexBuffer = IndexBuffer;
